import React from 'react'
import styled from 'styled-components'
import { assetPrefix } from 'config/env_config'

const Container = styled.div`
  display: flex;
  align-items: stretch;
  flex: 1 1 100%;
  margin: 5px;
`

const SpinerButton = styled.button`
  background-color: var(--cobasi-blue);
  border: none;
  border-radius: 3px;
  flex: 0 1 5rem;
  outline: none;
  pointer-events: ${props => props.active ? '' : 'none'};

  svg {
    opacity : ${props => props.active ? '1' : '0.5'};
    display:block;
    margin:auto;
    fill: var(--the-white);
    width: 1.8rem;
    height: 1.8rem;
  }
`
const NumericDisplay = styled.div`
  border: 0.1rem solid var(--dark-gray);;
  border-radius: 0.2rem;
  font-size: 1.4rem;
  padding: .8rem 0 1rem;
  flex: 1 0 30%;
  margin: 0 .5rem;
  text-align:center;
  line-height: 1.5rem;
  user-select: none;
`

class Spinner extends React.Component {
  state = {
    quantity: this.props.quantity || 1,
    onChangeCallback: this.props.onChange
  }

  handleDecreaseUnit = () => {
    const newQuantity = this.state.quantity - 1
    this.setState({
      quantity: newQuantity
    })
    this.state.onChangeCallback(newQuantity)
  }

  handleIncreaseUnit = () => {
    const newQuantity = this.state.quantity + 1
    this.setState({
      quantity: newQuantity
    })
    this.state.onChangeCallback(newQuantity)
  }

  isMinusButtonActive = (quantity) => {
    const minQuantity = this.props.minQuantity || 1
    return quantity > minQuantity
  }

  isAddButtonActive = (quantity) => {
    const maxQuantity = this.props.maxQuantity || 99
    return quantity < maxQuantity
  }

  render () {
    const { quantity } = this.state
    return (
      <Container data-test='container-spinner'>
        <SpinerButton data-test='spinnerbutton-minus' active={this.isMinusButtonActive(quantity)} onClick={this.handleDecreaseUnit}>
          <svg>
            <use xlinkHref={`${assetPrefix}/static/icons.svg#icon-minus`} />
          </svg>
        </SpinerButton>
        <NumericDisplay data-test='numericDisplay'>{quantity}</NumericDisplay>
        <SpinerButton data-test='spinnerbutton-plus' active={this.isAddButtonActive(quantity)} onClick={this.handleIncreaseUnit}>
          <svg>
            <use xlinkHref={`${assetPrefix}/static/icons.svg#icon-plus`} />
          </svg>
        </SpinerButton>
      </Container>
    )
  }
}

export default Spinner
